var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import { createAction, createAsyncThunk, createSelector, createSlice, isAnyOf, } from '@reduxjs/toolkit';
import { v4 } from 'uuid';
import { DocumentUploadsStatus, DocumentUploadsValidationError, } from '../../types/document-uploads';
import { getClient, initializeClient } from '../../clients/link-api';
import fetchWrapper from '../../clients/fetchWrapper';
export var MAX_ALLOWED_FILE_SIZE_MB = 20;
export var initialState = {
    failedLoginAttempts: 0,
    stagedDocuments: [],
};
var fetchPreSignedUrl = createAsyncThunk('documentUploads/fetchPreSignedUrl', function (_a, _b) {
    var linkToken = _a.linkToken, modalSessionId = _a.modalSessionId, uniqueUserId = _a.uniqueUserId, documentId = _a.documentId, documentType = _a.documentType, documentName = _a.documentName;
    var fulfillWithValue = _b.fulfillWithValue, rejectWithValue = _b.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var client, response, e_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    client = getClient() ||
                        initializeClient(linkToken, uniqueUserId, {
                            __headers: {
                                modal_session_id: modalSessionId,
                            },
                        });
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, client.fetchPreSignedUrl(documentType, documentName)];
                case 2:
                    response = _c.sent();
                    if ('error' in response) {
                        return [2 /*return*/, rejectWithValue({ error: response.error.message }, { documentId: documentId })];
                    }
                    return [2 /*return*/, fulfillWithValue({ preSignedUrl: response.preSignedUrl }, { documentId: documentId })];
                case 3:
                    e_1 = _c.sent();
                    return [2 /*return*/, rejectWithValue({ error: e_1.message }, { documentId: documentId })];
                case 4: return [2 /*return*/];
            }
        });
    });
});
var uploadToPreSignedUrl = createAsyncThunk('documentUploads/uploadToPreSignedUrl', function (_a, _b) {
    var documentId = _a.documentId, preSignedUrl = _a.preSignedUrl, documentFile = _a.documentFile;
    var fulfillWithValue = _b.fulfillWithValue, rejectWithValue = _b.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var e_2;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fetchWrapper(preSignedUrl, {
                            method: 'PUT',
                            body: documentFile,
                            headers: {
                                'Content-Type': documentFile.type,
                            },
                        })];
                case 1:
                    _c.sent();
                    return [2 /*return*/, fulfillWithValue(true, { documentId: documentId })];
                case 2:
                    e_2 = _c.sent();
                    return [2 /*return*/, rejectWithValue({ error: e_2.message }, { documentId: documentId })];
                case 3: return [2 /*return*/];
            }
        });
    });
}, {
    getPendingMeta: function (_a) {
        var _b = _a.arg, documentId = _b.documentId, preSignedUrl = _b.preSignedUrl;
        return ({
            documentId: documentId,
            preSignedUrl: preSignedUrl,
        });
    },
});
export var stageDocument = createAction('documentUploads/stageDocument');
var validateDocumentFile = function (documentFile) {
    if (documentFile.size > MAX_ALLOWED_FILE_SIZE_MB * 1024 * 1024) {
        return DocumentUploadsValidationError.MAX_FILE_SIZE_EXCEEDED;
    }
    if (!documentFile.type.startsWith('image/') &&
        documentFile.type !== 'application/pdf') {
        return DocumentUploadsValidationError.UNSUPPORTED_FILE_TYPE;
    }
    return undefined;
};
/**
 * Wrapper async thunk which handles the entire flow of uploading a file to S3.
 * The overall logic flow here is as follows:
 * 1. A new document entry is added to `stagedDocuments` with status `QUEUED`.
 *    If `documentId` corresponds to an existing document, then instead of
 *    adding a new entry, the previous entry will be replaced/overwritten.
 * 2. [TODO] Perform validation checks on the selected file (e.g. file size)
 * 3. Dispatch `fetchPreSignedUrl` to fetch a new pre-signed URL from the BE.
 *   a) If the request fails, update the status of the document to `FAILED`.
 *      This is handled by the `fetchPreSignedUrl.rejected` reducer.
 * 4. Dispatch `uploadToPreSignedUrl` to upload the document file to S3 using
 *    the URL fetched from the previous step.
 *   a) The `uploadToPreSignedUrl.pending` reducer updates the document's status
 *      to `UPLOADING` and sets its `preSignedUrl` field.
 *   b) The `uploadToPreSignedUrl.fulfilled` reducer updates the document's
 *   status to `UPLOADED` once the upload request has succeeded.
 *   c) If the request fails, update the status of the document to `FAILED`.
 *      This is handled by the `uploadToPreSignedUrl.rejected` reducer.
 */
export var uploadNewDocument = createAsyncThunk('documentUploads/uploadNewDocument', function (_a, _b) {
    var linkToken = _a.linkToken, modalSessionId = _a.modalSessionId, uniqueUserId = _a.uniqueUserId, customOrExistingDocumentId = _a.customOrExistingDocumentId, documentType = _a.documentType, documentFile = _a.documentFile;
    var dispatch = _b.dispatch, rejectWithValue = _b.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var documentId, validationError, preSignedUrl;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    documentId = customOrExistingDocumentId !== null && customOrExistingDocumentId !== void 0 ? customOrExistingDocumentId : v4();
                    dispatch(stageDocument({
                        customOrExistingDocumentId: documentId,
                        documentName: documentFile.name,
                        documentType: documentType,
                    }));
                    validationError = validateDocumentFile(documentFile);
                    if (validationError) {
                        throw rejectWithValue({
                            validationError: validationError,
                        }, { documentId: documentId });
                    }
                    return [4 /*yield*/, dispatch(fetchPreSignedUrl({
                            linkToken: linkToken,
                            modalSessionId: modalSessionId,
                            uniqueUserId: uniqueUserId,
                            documentId: documentId,
                            documentType: documentType,
                            documentName: documentFile.name,
                        })).unwrap()];
                case 1:
                    preSignedUrl = (_c.sent()).preSignedUrl;
                    return [4 /*yield*/, dispatch(uploadToPreSignedUrl({
                            documentId: documentId,
                            preSignedUrl: preSignedUrl,
                            documentFile: documentFile,
                        }))];
                case 2:
                    _c.sent();
                    return [2 /*return*/];
            }
        });
    });
});
export var documentUploadsSlice = createSlice({
    name: 'documentUploads',
    initialState: initialState,
    reducers: {
        incrementFailedLoginAttempts: function (state) {
            state.failedLoginAttempts++;
        },
        unstageDocument: function (state, action) {
            state.stagedDocuments = state.stagedDocuments.filter(function (entry) { return entry.id !== action.payload; });
        },
    },
    extraReducers: function (builder) {
        builder.addCase(stageDocument, function (state, action) {
            var _a = action.payload, customOrExistingDocumentId = _a.customOrExistingDocumentId, documentType = _a.documentType, documentName = _a.documentName;
            var newDocument = {
                id: customOrExistingDocumentId,
                type: documentType,
                name: documentName,
                status: DocumentUploadsStatus.QUEUED,
            };
            var existingDocumentIdx = state.stagedDocuments.findIndex(function (doc) { return doc.id === customOrExistingDocumentId; });
            // If the documentId corresponds to an existing document, replace it but
            // preserve its position/index in the staged documents list.
            if (existingDocumentIdx !== -1) {
                state.stagedDocuments[existingDocumentIdx] = newDocument;
            }
            else {
                state.stagedDocuments.push(newDocument);
            }
        });
        builder.addCase(uploadToPreSignedUrl.pending, function (state, action) {
            var _a = action.meta, documentId = _a.documentId, preSignedUrl = _a.preSignedUrl;
            var document = state.stagedDocuments.find(function (doc) { return doc.id === documentId; });
            if (document) {
                Object.assign(document, {
                    status: DocumentUploadsStatus.UPLOADING,
                    preSignedUrl: preSignedUrl,
                });
            }
        });
        builder.addCase(uploadToPreSignedUrl.fulfilled, function (state, action) {
            var documentId = action.meta.documentId;
            var document = state.stagedDocuments.find(function (doc) { return doc.id === documentId; });
            if (document) {
                document.status = DocumentUploadsStatus.UPLOADED;
            }
        });
        // Sets the document status to `ERROR` if there was a validation error. All
        // other errors/failures (e.g. network errors) are handled by the reducers
        // for `fetchPreSignedUrl.rejected` and `uploadToPreSignedUrl.rejected`.
        builder.addCase(uploadNewDocument.rejected, function (state, action) {
            var documentId = action.meta.documentId;
            var document = state.stagedDocuments.find(function (doc) { return doc.id === documentId; });
            if (!document)
                return;
            if ('validationError' in action.payload) {
                var validationError = action.payload.validationError;
                Object.assign(document, {
                    status: DocumentUploadsStatus.ERROR,
                    validationError: validationError,
                });
            }
        });
        builder.addMatcher(
        // Handles all network/response/unhandled error cases by setting the
        // document status to `FAILED`.
        isAnyOf(fetchPreSignedUrl.rejected, uploadToPreSignedUrl.rejected), function (state, action) {
            var documentId = action.meta.documentId;
            var document = state.stagedDocuments.find(function (doc) { return doc.id === documentId; });
            if (document) {
                // Note: all error cases are handled the same way currently (e.g.
                // network error, 400/500 response, etc.), but we may want to set
                // different statuses and/or error messages for these in the future.
                document.status = DocumentUploadsStatus.FAILED;
            }
        });
    },
});
export var incrementFailedLoginAttempts = (_a = documentUploadsSlice.actions, _a.incrementFailedLoginAttempts), unstageDocument = _a.unstageDocument;
export var selectFailedLoginAttempts = function (state) {
    return state.documentUploads.failedLoginAttempts;
};
export var selectStagedDocuments = function (state) {
    return state.documentUploads.stagedDocuments;
};
export var selectStagedDocumentById = createSelector([selectStagedDocuments, function (state, fileId) { return fileId; }], function (stagedDocuments, fileId) {
    return stagedDocuments.filter(function (sd) { return sd.id === fileId; })[0];
});
export var selectStagedDocumentsByStatus = createSelector([selectStagedDocuments, function (state, status) { return status; }], function (stagedDocuments, status) {
    return stagedDocuments.filter(function (sd) { return sd.status === status; });
});
export default documentUploadsSlice.reducer;
export var selectDocumentUploads = function (state) { var _a, _b; return (_b = (_a = state.linkParams) === null || _a === void 0 ? void 0 : _a.linkTokenPayload) === null || _b === void 0 ? void 0 : _b.documentUploads; };
